import { AuthService } from './../../core/services/auth.service';
import { SnackBarService } from './../../core/services/snack-bar.service';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import formatDate from '../../helpers/format-date';
import { AddOrEditUserModalComponent } from '../add-or-edit-user-modal/add-or-edit-user-modal.component';
import { UserService } from '../../core/services/user.service';
import { IUser, UserRoles } from '../../../models/User';
import { FirebaseService } from 'src/app/core/services/firebase.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-user-details-modal',
  templateUrl: './user-details-modal.component.html',
  styleUrls: ['./user-details-modal.component.scss']
})
export class UserDetailsModalComponent implements OnInit, OnDestroy {
  disableEdit = false;
  loggedUser: IUser;
  imageUrl: string = '';
  formatDate = formatDate;
  @ViewChild('notification', { static: true }) notificationTmpl;
  notificationData: { type: string, title: string, message: string } | null;

  public get enableChangePassword() {
    return this.loggedUser.type === UserRoles.MASTER && (this.loggedUser.id === this.data.user.id || this.data.user.type !== UserRoles.MASTER);
  }

  constructor(
    public dialogRef: MatDialogRef<UserDetailsModalComponent>,
    private dialog: MatDialog,
    private userService: UserService,
    private firebaseService: FirebaseService,
    private notificationService: SnackBarService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: { user: IUser, disableEditAdmins: boolean }
  ) { }

  ngOnInit(): void {
    this.loggedUser = this.userService.getLoggedUser();
    this.getUserPicture();

    this.firebaseService.imageUploaded$.subscribe(uploaded => {
      if (uploaded) {
        this.getUserPicture();
      }
    });

    if (this.data.disableEditAdmins) {
      this.disableEdit = this.loggedUser.type !== UserRoles.MASTER && this.loggedUser.type !== UserRoles.ADMIN;
    }
  }

  ngOnDestroy(): void {
    this.firebaseService.imageUploaded$.unsubscribe();
  }

  openEditUser(): void {
    const dialogRef = this.dialog.open(AddOrEditUserModalComponent, {
      panelClass: 'details-modal',
      width: '70vw',
      autoFocus: false,
      data: { user: this.data.user }
    });
    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.dialogRef.close(user);
      }
    });
  }

  openPasswordChangeModal() {
    this.dialog.open(ChangePasswordComponent, {
      panelClass: 'details-modal',
      width: '39rem',
      height: '24rem',
      autoFocus: false,
      data: { user: this.data.user, showWarning: this.loggedUser.id === this.data.user.id }
    }).afterClosed().subscribe(userId => {
      if (userId.length > 0) {
        if (userId === this.loggedUser.id) {
          this.redirectToLogin();
          return;
        }
        this.notificationData = {
          type: 'success',
          title: 'Senha alterada!',
          message: `A senha do usuário foi atualizada com sucesso.`
        };
        const notificationId = '77';
        this.notificationService.showFeedback(this.notificationTmpl, this.notificationData, notificationId);
        setTimeout(() => {
          this.notificationData = null;
          this.notificationService.hideNotification(notificationId);
        }, 5000);
      }
    });
  }

  disabledTooltipText(): string {
    if (this.data.disableEditAdmins) {
      if (this.loggedUser.type !== UserRoles.MASTER && this.loggedUser.type !== UserRoles.ADMIN) {
        return 'Você não possui cargo para editar os usuários.';
      }
    }
    return '';
  }

  close(): void {
    this.dialogRef.close();
  }

  async getUserPicture() {
    this.imageUrl = await this.firebaseService.getUserPicture(this.data.user.id);
  }

  redirectToLogin() {
    this.notificationData = {
      type: 'success',
      title: 'Senha alterada!',
      message: `Você será redirecionado para a tela de login. Por favor, faça login novamente com sua nova senha.`
    };
    const notificationId = '77';
    this.notificationService.showFeedback(this.notificationTmpl, this.notificationData, notificationId);
    this.dialogRef.close();
    setTimeout(() => {
      this.notificationData = null;
      this.notificationService.hideNotification(notificationId);
      this.authService.isLoggedIn$.next(false);
      localStorage.clear();
      window.location.reload();
    }, 8000);
  }

}
